// extracted by mini-css-extract-plugin
module.exports = {"container":"_6eb00b8e53--container--tki8s","title":"_6eb00b8e53--title--2Rty1","message":"_6eb00b8e53--message--3sL3b"};